import { useTranslation } from 'react-i18next'

import { FLOATING_ELEMENT_PLACEMENT } from '../../../constants/common'
import { ActionSelect, getActionSelectOptions } from '../../Action'
import Button, { BUTTON_HEIGHT_24 } from '../../Button'
import { TableRowContextActionsContainer } from '../TableRowContextActionsContainer'

import {
  QA_NAME_TABLE_ROW_ACTIONS,
  TABLE_ROW_CONTEXT_ACTIONS_DROPDOWN_STYLES,
} from './TableRowContextActions.constants'

import * as styles from './TableRowContextActions.module.css'

function TableRowContextActions({
  getActions,
  item,
  onCallAction,
  ...restProps
}) {
  const { t } = useTranslation()

  const options = getActionSelectOptions({
    actions: getActions(item),
    t,
  })

  function handleClickAction(action) {
    onCallAction(action, item)
  }

  return (
    <TableRowContextActionsContainer
      {...restProps}
      Component={ActionSelect}
      actions={options}
      controlProps={{
        buttonProps: {
          Button: Button.Text,
          height: BUTTON_HEIGHT_24,
          qaName: QA_NAME_TABLE_ROW_ACTIONS,
        },
        className: styles.actionSelectControl,
      }}
      dropdownFloatingConfig={{
        dropdownStyles: TABLE_ROW_CONTEXT_ACTIONS_DROPDOWN_STYLES,
        flipConfig: {
          fallbackPlacements: [FLOATING_ELEMENT_PLACEMENT.topEnd],
        },
      }}
      item={item}
      qaName={QA_NAME_TABLE_ROW_ACTIONS}
      onClickAction={handleClickAction}
    />
  )
}

export default TableRowContextActions
